<template>
    <div class="pr-md-4 pl-md-4 pl-3 pr-3 step-2">
        <Heading v-html="heading" />
        <Subheading v-html="subheading" />

        <component
            :is="stepForm"
            :paymentType="'single'"
        />

        <div class="flex-container row2 go-back">
            <router-link to="/">&lt; Wstecz</router-link>
        </div>

        <PersonalDataAdministratorInfo :showInfo="true" />
    </div>
</template>

<script>
import Heading from '@/components/atoms/Heading';
import Subheading from '@/components/atoms/Subheading';
import CommonSecondStepForm from '@/components/organisms/CommonSecondStepForm';
import PersonalDataAdministratorInfo from '@/components/molecules/PersonalDataAdministratorInfo';

export default {
    name: 'StepTwo',
    data () {
        return {
            heading: 'Uzupełnij swoje dane',
            subheading: '- potrzebujemy Twoich danych do realizacji płatności.<br><span class="requirements"><span class="text-danger">*</span> Pola obowiązkowe.</span>',
        }
    },
    computed: {
        stepForm () {
            return 'CommonSecondStepForm';
        }
    },
    components: {
        PersonalDataAdministratorInfo,
        Subheading,
        Heading,
        CommonSecondStepForm,
    },
}
</script>

<style scoped>
</style>
